module.exports = __webpack_public_path__ + "img/builder-35.001411f6.webp";